<template>
  <div class="xlfafx-wrap">
    <div class="left" v-show="tabShow">
      <el-input
        placeholder="输入关键字进行过滤"
        v-model="filterText"
      ></el-input>
      <el-tree
        class="filter-tree"
        :data="leftTreeData"
        node-key="id"
        :props="defaultProps"
        default-expand-all
        :highlight-current="true"
        :filter-node-method="filterNode"
        :expand-on-click-node="false"
        ref="tree"
        @node-click="handleNodeClick"
      ></el-tree>
    </div>
    <div
      class="right"
      :style="{ width: tabShow ? 'calc(100% - 260px)' : '100%' }"
    >
      <btn-show @show="tabShow = !tabShow" content="左边树"></btn-show>
      <div class="search-box box" style="height: 36px; line-height: 36px">
        <time-search
          ref="timeSearch"
          :control="{ data: timeData }"
          @timeControlChange="timeControlChange"
          @timeControlClick="TimeControlClick"
        ></time-search>
      </div>
      <div class="right-content" v-loading="loading">
        <div class="chart-content" id="echartContent"></div>
        <div class="table-content">
          <nk-table :data="nkTableData" :columns="columns"></nk-table>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import NkTable from "@/components/common/NkTable.vue";
import BtnShow from "@/components/common/BtnShow.vue";
import TimeSearch from "@/components/common/TimeSearch.vue";
import * as utils from "@/utils/index.js";
import tree from "@/utils/tree.js";
import { formatTime, formatDate } from "@/utils/index";
import { pseudoRandomBytes } from "crypto";
import { isNull, isUndefined } from "util";
import handleData from "@/utils/handleData.js";
import calc from "./calc.js";
let eleTimeData = [
  {
    type: "month",
    label: "月",
  },
  // {
  //   type: "year",
  //   label: "年",
  // },
];
export default {
  components: {
    BtnShow,
    NkTable,
    TimeSearch,
  },
  data() {
    return {
      tabShow: true,
      timeData: eleTimeData,
      treeTabObj: null,
      leftTreeData: [],
      defaultProps: {
        children: "children",
        label: "name",
      },
      filterText: "",
      alarnclass: "alarnclass", //时段需要选分秒
      timeInterval: "toDay",
      timeType: [
        { value: "2", label: "月" },
        // { value: "5", label: "年" },
      ],
      columns: [
        { prop: "label", width: 200, label: "" },
        { prop: "max", label: "最大需量（kw）" },
        { prop: "maxTime", label: "最大需量发生时间" },
        { prop: "powerRate", label: "基本电费" },
        { prop: "difference", label: "基本电费差额" },
      ],
      nkTableData: [],

      resData: [],
      myCharts: [],
      loading: true,
      selectedDate: {
        startTime: "",
        endTime: "",
      },
    };
  },
  created() {
    let vm = this;
    vm.getORGStructNodes();
  },
  mounted() {
    let vm = this;
    vm.$eventBus.$on("changeCompanyId", (companyId) => {
      vm.getORGStructNodes();
    });
  },
  methods: {
    filterNode(value, data) {
      if (!value) return true;
      return data.name.indexOf(value) !== -1;
    },
    getORGStructNodes() {
      let vm = this;
      vm.$api.orgStructNode
        .getORGStructNodes(this.$store.state.user.currentCompanyId)
        .then((res) => {
          vm.leftTreeData = tree.creatTreeJson(res.data, 0);
          console.log(vm.leftTreeData);
          vm.selectNodes = [vm.leftTreeData[0]];
          //设置默认选中第一个
          vm.defaultCheckedKeys = [vm.leftTreeData[0].id];
          vm.fistcheck = vm.leftTreeData[0];
          vm.$nextTick((callback) => {
            vm.$refs.tree.setCurrentKey(vm.leftTreeData[0].id);
          });
          vm.getAllDemandByOrg();
        });
    },
    bindgetSearchElem(e) {
      let vm = this;
      vm.elem = vm.$refs.search.getElem();
      vm.getAllDemandByOrg();
    },
    timeControlChange(e) {
      let vm = this;
      vm.selectedDate = e;
    },
    TimeControlClick(e) {
      let vm = this;
      vm.selectedDate = e;
      vm.getAllDemandByOrg();
    },
    getAllDemandByOrg() {
      let vm = this;
      let startTime = vm.selectedDate.startTime,
        endTime = vm.selectedDate.endTime,
        orgId = vm.selectNodes[0].id,
        className = "IsTransformer";
      vm.loading = true;
      //获取方案
      Promise.all([
        vm.$api.nhtj.getPointedDemandSchemeInfo(orgId, 0, null),
        vm.$api.nhtj.getAllDemandByOrg(startTime, endTime, orgId, className, 0),
      ]).then((resArr) => {
        if (resArr[1].data.length == 0) {
          vm.nkTableData = [];
          vm.loadEChart([]);
          vm.loading = false;
          return;
        }
        //获取所有方案。线的条数为方案总数加一
        let arr = resArr[0].data;
        //data 每个方案的推移时间的data
        let data = [];
        // //获取总的
        let allData = [];
        for (let index = 0; index < resArr[1].data.length; index++) {
          allData.push(resArr[1].data[index].data);
        }
        //计算最大需量
        let allItem = {};
        let oldObj = calc.clcaDemandMax(JSON.parse(JSON.stringify(allData)));
        allItem.name = "实际";
        allItem.max = oldObj.max.toFixed(2);
        allItem.maxTime = oldObj.time;
        allItem.oldVal = (oldObj.max * 32).toFixed(2);
        allItem.newVal = (oldObj.max * 32).toFixed(2);
        allItem.oldData = oldObj.data;
        allItem.newData = [];
        console.log(oldObj.data);
        allItem.differ = (allItem.newVal - allItem.oldVal).toFixed(2);
        data.push(allItem);

        //循环获取每一个方案里面的计量点的需量
        for (let k = 1; k < arr.length; k++) {
          const item = arr[k];
          if (item.isPointed == 1) {
            let dataItem = {
              name: item.displayName, //方案名称
              oldStData: [], //接口返回数据
              newStData: [], //接口返回的调整后的数据
              oldData: [], //合并后的总数据
              newData: [], //合并后的调整总数据
              max: "-", //调整的最大值
              maxTime: "-", //调整的最大值对应时间
              oldVal: "-", //基本电费
              newVal: "-", //调整后的基本电费
              differ: "-", //电费差值
            };
            for (let j = 0; j < item.detail.length; j++) {
              let itemMeasure = resArr[1].data.find(
                (obj) => obj.measureId === item.detail[j].measureId
              );
              if (itemMeasure) {
                dataItem.oldStData.push(itemMeasure.data);
                console.log(itemMeasure.data);
                let reData = calc.overTimeToArr(
                  JSON.parse(JSON.stringify(itemMeasure.data)),
                  item.detail[j].demandType
                );
                dataItem.newStData.push(reData);
              }
            }
            //计算最大需量
            let oldObj = calc.clcaDemandMax(
              JSON.parse(JSON.stringify(dataItem.oldStData))
            );
            let newObj = calc.clcaDemandMax(
              JSON.parse(JSON.stringify(dataItem.newStData))
            );
            dataItem.max = newObj.max.toFixed(2);
            dataItem.maxTime = newObj.time;
            dataItem.oldVal = (oldObj.max * 32).toFixed(2);
            dataItem.newVal = (newObj.max * 32).toFixed(2);
            dataItem.oldData = oldObj.data;
            dataItem.newData = newObj.data;
            dataItem.differ = (dataItem.newVal - dataItem.oldVal).toFixed(2);
            data.push(dataItem);
          }
        }
        vm.loadEChart(data);
        vm.loading = false;
      });
    },
    handleNodeClick(e) {
      let vm = this;
      vm.selectNodes[0] = e;
      console.log(e);
      // vm.elem = vm.$refs.search.getElem();
      vm.getAllDemandByOrg();
    },
    loadEChart(arr) {
      let vm = this;
      vm.nkTableData = [];
      let echartContent = document.getElementById("echartContent");
      var childs = echartContent.childNodes;
      for (var i = childs.length - 1; i >= 0; i--) {
        echartContent.removeChild(childs[i]);
      }
      let option = {
        title: {
          text: "实际需量与调整需量",
          left: "center",
        },
        tooltip: {
          trigger: "axis",
        },
        toolbox: {
          show: true,
          right: 20,
          feature: {
            saveAsImage: {},
            magicType: {
              type: ["line", "bar"],
            }, //切换为折线图，切换为柱状图
          },
        },
        grid: {
          left: "50px",
          right: "50px",
          top: "60px",
        },
        legend: {
          data: [],
          left: "center",
          top: "30px",
        },
        dataZoom: [
          {
            type: "inside",
            show: true,
            realtime: true,
          },
          {
            show: true,
            realtime: true,
            end: 100,
            type: "slider",
            width: "96%",
            left: "center",
          },
        ],
        color: "#00AAFF",
        xAxis: {
          data: [],
        },
        yAxis: [
          {
            name: "kw",
            type: "value",
            scale: true,
          },
        ],
        series: [
          {
            name: [],
            type: "line",
            data: [],
          },
        ],
      };
      if (arr.length == 0) {
        let dom = document.createElement("div");
        dom.style.width = "100%";
        dom.style.height = "400px";
        echartContent.appendChild(dom);
        let chart = vm.$echarts.init(dom);
        chart.setOption(option);
        return;
      }
      for (let index = 0; index < arr.length; index++) {
        const element = arr[index];
        let dom = document.createElement("div");
        dom.style.width = "100%";
        dom.style.height = "300px";
        echartContent.appendChild(dom);
        let chart = vm.$echarts.init(dom);
        option.title.text = element.name;
        if (index == 0) {
          option.legend.data = ["实际需量"];
          let xAxisData = [];
          let arrLine1 = [];
          let seriesData = [];
          for (let j = 0; j < arr[index].oldData.length; j++) {
            xAxisData.push(arr[index].oldData[j].time);
            arrLine1.push(arr[index].oldData[j].value.toFixed(2));
          }
          option.xAxis.data = xAxisData;
          option.series[0] = {
            name: "实际需量",
            type: "line",
            data: arrLine1,
          };
        } else {
          option.legend.data = ["实际需量", "调整需量"];
          let xAxisData = [];
          let seriesData = [];
          let arrLine1 = [];
          let arrLine2 = [];
          for (let j = 0; j < arr[index].oldData.length; j++) {
            xAxisData.push(arr[index].oldData[j].time);
            arrLine1.push(arr[index].oldData[j].value.toFixed(2));
          }
          for (let j = 0; j < arr[index].newData.length; j++) {
            arrLine2.push(arr[index].newData[j].value.toFixed(2));
          }
          option.xAxis.data = xAxisData;
          option.series[0] = {
            name: "实际需量",
            type: "line",
            data: arrLine1,
          };
          option.series[1] = {
            name: "调整需量",
            type: "line",
            data: arrLine2,
          };
        }
        chart.setOption(option);
        vm.nkTableData.push({
          label: element.name,
          max: element.max,
          maxTime: element.maxTime,
          powerRate: element.newVal,
          difference: element.differ,
        });
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.xlfafx-wrap {
  width: 100%;
  height: 100%;
  padding: 14px;
  box-sizing: border-box;
  display: flex;
  .left {
    width: 260px;
    flex: 0 0 260px;
    border-radius: 4px;
    background: #ffffff;
    display: flex;
    flex-flow: column;
  }
  .right {
    flex: 1;
    margin-left: 14px;
    position: relative;
    overflow: auto;
    .right-content {
      height: calc(100% - 50px);
      border-radius: 4px;
      overflow-y: auto;
      overflow-x: hidden;
      margin-top: 14px;
    }
    .chart-content {
      width: 100%;
      background: #ffffff;
    }
    .table-content {
      width: 100%;
      height: 200px;
      margin-top: 14px;
      background: #ffffff;
    }
  }
}
</style>
